<template>
  <div
    :class="[
      'textarea',
      invalid && 'textarea_error',
      theme && `textarea_theme_${theme}`,
      withClear && `textarea_with-clear`,
    ]"
  >
    <textarea
      class="textarea__control"
      :id="id"
      v-model.trim="model"
      :placeholder="placeholder"
      :disabled="disabled"
      :required="required"
      :rows="rows"
      type="text"
    >
    </textarea>
    <span v-if="withClear" class="textarea__clear" id="textarea-clear" @click="clear">
      <slot name="clear-icon">
        <font-awesome-icon :icon="['far', 'times']" />
      </slot>
    </span>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import FormField from '@/mixins/FormField';

export default {
  name: 'TextArea',

  components: {
    FontAwesomeIcon,
  },

  mixins: [FormField],
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/variables';

@mixin placeholder {
  font-size: 14px;
  font-weight: 200;
  color: #bfbfbf;
}

.textarea {
  display: block;
  position: relative;

  &__control {
    font-size: 16px;
    width: 100%;
    padding: 10px;
    color: #4a4a4a;
    border: 1px solid $default-text-grey;
    border-radius: 4px;
    box-sizing: border-box;
    transition: border-color 0.25s, color 0.25s;
    resize: vertical;

    &:focus,
    &:hover {
      border-color: $default-blue;
    }

    &::-webkit-input-placeholder {
      @include placeholder;
    }

    &:-ms-input-placeholder {
      @include placeholder;
    }

    &::-ms-input-placeholder {
      @include placeholder;
    }

    .textarea_theme_dark & {
      color: white;
      background: $default-component-grey;
      border-color: transparent;
    }

    .textarea_error & {
      border-color: $error-red;
    }

    .textarea_with-clear & {
      padding-right: 32px;
    }

    &[disabled] {
      background: #414141;
    }
  }

  &__clear {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    opacity: 0.75;

    &:hover {
      cursor: pointer;
      opacity: 1;
    }
  }
}
</style>
